@if (health; as health) {
  <strong [class.export-failed]="health.status === 'failed'">
    {{health.status === 'failed' ? 'Export failed' : 'Delivered'}}
  </strong>
  <div>{{health.attemptedAt | date:'medium'}}</div>
  @if (health.status === 'failed') {
    <div>{{health.message}}</div>
    <div>Reason: {{health.reason}}@if (health.httpStatus) {
      <span> (HTTP {{health.httpStatus}})</span>
    }</div>
    <div>Failing since: {{health.firstFailedAt | date:'medium'}}</div>
    <div>Consecutive failures: {{health.consecutiveFailures}}</div>
    <div>{{health.action}}</div>
  }
  <div>Last successful export: {{health.lastSuccessfulAt ? (health.lastSuccessfulAt | date:'medium') : 'Not recorded'}}</div>
  @if (health.lastFailure) {
    <div>Last failure: {{health.lastFailure.attemptedAt | date:'medium'}} ({{health.lastFailure.stage}})</div>
  }
  <div>Records in batch: {{health.recordCount}}</div>
  <div class="batch-id">Batch: {{health.batchId}}</div>
} @else {
  Not recorded
}
